import { FC, SVGAttributes } from 'react';

const ArrowForward: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" {...props}>
      <path
        d="M13.3407 4.4716C12.9111 4.04202 12.2147 4.04202 11.7851 4.4716C11.3555 4.90117 11.3555 5.59765 11.7851 6.02723L16.6582 10.9004H4.68789C4.08038 10.9004 3.58789 11.3929 3.58789 12.0004C3.58789 12.6079 4.08038 13.1004 4.68789 13.1004H16.6563L11.7851 17.9716C11.3555 18.4012 11.3555 19.0976 11.7851 19.5272C12.2147 19.9568 12.9111 19.9568 13.3407 19.5272L20.0907 12.7772C20.5203 12.3477 20.5203 11.6512 20.0907 11.2216L13.3407 4.4716Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowForward;
